// 2025-05-04 swiperのエフェクトを使うために追加
import { EffectCube } from 'swiper/modules';
import 'swiper/css/effect-cube';

Swiper.use([EffectCube]);

import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { setSwiperInstance } from "@/helpers/swiperInstance";

export default function initSwiper(options = {}) {
  let swiper;

  if (window.storeeelItems.isMobile) {
    if (window.storeeelItems.frame === "circle") {
      // モバイルかつcircleフレームなら cube エフェクトで初期化
      swiper = new Swiper(".storeeelSwiper", {
        effect: "cube",
        grabCursor: true,
        slidesPerView: 1,
        cubeEffect: {
          shadow: false,
          slideShadows: false,
          shadowOffset: 0,
          shadowScale: 0.94,
        },
        initialSlide: options.initialSlide || 0,
      });
    } else {
      // モバイルだが frameがcircleでない
      // 05-05 縦方向にスライドするよう調整
      swiper = new Swiper(".storeeelSwiper", {
        direction: 'vertical',
        effect: 'slide',
        slidesPerView: 1,
        spaceBetween: 0,
        mousewheel: true,
        threshold: 10,
        resistanceRatio: 2000,
        speed: 200,
        // 無限に高さが調整される要因？
        // autoHeight: true,
        initialSlide: options.initialSlide || 0,
        touchStartPreventDefault: false,
        passiveListeners: false,
      });
    }
  } else {
    if (window.storeeelItems.frame === "circle") {
      // PCかつcircle → 特別な処理があればここに書く
    }

    // PC 通常
    swiper = new Swiper(".storeeelSwiper", {
      centeredSlides: true,
      loop: false,
      allowTouchMove:false,
      slidesPerView: 2.6,
      spaceBetween: 0,
      speed: 400,
      initialSlide: options.initialSlide || 0,
    });
  }

  setSwiperInstance(swiper);
}
